import fs from 'node:fs'
import type { LoadedAuthoredGeneratedSchema } from '@cli-types/core-engine/add-field.js'
import { stringifyProjectJson } from '@cli-utils/shared.js'

export function writeAuthoredGeneratedSchema(loaded: LoadedAuthoredGeneratedSchema): void {
  fs.writeFileSync(loaded.filePath, stringifyProjectJson(loaded.schema), 'utf-8')
}
